import { Vector3 } from 'three';
import { WallTypeEnum } from '../../interfaces/GenericInterfaces';
import { WallMovementConstraintDTO } from '../DTOs/WallPositionConstraintDTO';
import { MovementOffset } from './MovementOffset';
export class WallMovementConstraint {
  public static fromDTO(movementDataDTO: WallMovementConstraintDTO) {
    let linkVector: Vector3 | undefined;

    if (
      movementDataDTO.linkVector === undefined || // Checks if linkVector itself is not defined
      movementDataDTO.linkVector.length < 3 || // Checks if linkVector does not have 3 elements
      movementDataDTO.linkVector[0] === undefined || // Checks if the first element is undefined
      movementDataDTO.linkVector[1] === undefined || // Checks if the second element is undefined
      movementDataDTO.linkVector[2] === undefined // Checks if the third element is undefined
      // eslint-disable-next-line
    ) {
    } else {
      linkVector = new Vector3(
        movementDataDTO.linkVector[0],
        movementDataDTO.linkVector[1],
        movementDataDTO.linkVector[2],
      );
    }

    return new WallMovementConstraint(
      movementDataDTO.wallType,
      MovementOffset.fromDTO(movementDataDTO.topOffset),
      MovementOffset.fromDTO(movementDataDTO.bottomOffset),
      MovementOffset.fromDTO(movementDataDTO.leftOffset),
      MovementOffset.fromDTO(movementDataDTO.rightOffset),
      linkVector,
      movementDataDTO.productOffset,
    );
  }

  private _wallType: WallTypeEnum;
  private _topOffset: MovementOffset;
  private _bottomOffset: MovementOffset;
  private _leftOffset: MovementOffset;
  private _rightOffset: MovementOffset;
  private _linkVector?: Vector3;
  private _productOffset?: number;

  public get wallType() {
    return this._wallType;
  }

  public get topOffset() {
    return this._topOffset;
  }

  public get bottomOffset() {
    return this._bottomOffset;
  }

  public get leftOffset() {
    return this._leftOffset;
  }

  public get rightOffset() {
    return this._rightOffset;
  }

  public get linkVector() {
    return this._linkVector;
  }

  public get productOffset() {
    return this._productOffset;
  }

  constructor(
    wallType: WallTypeEnum,
    topOffset: MovementOffset,
    bottomOffset: MovementOffset,
    leftOffset: MovementOffset,
    rightOffset: MovementOffset,
    linkVector?: Vector3,
    productOffset?: number,
  ) {
    this._wallType = wallType;
    this._topOffset = topOffset;
    this._bottomOffset = bottomOffset;
    this._leftOffset = leftOffset;
    this._rightOffset = rightOffset;
    this._linkVector = linkVector;
    this._productOffset = productOffset;
  }

  public toDTO() {
    return new WallMovementConstraintDTO(
      this.wallType,
      this.topOffset.toDTO(),
      this.bottomOffset.toDTO(),
      this.leftOffset.toDTO(),
      this.rightOffset.toDTO(),
      this.linkVector ? [this.linkVector.x, this.linkVector.y, this.linkVector.z] : undefined,
      this.productOffset,
    );
  }
}
